import { IQuantity, Quantity } from "../../../common/models/quantity.model";

interface IActions {
  openPanelToConfirm: () => void;
  confirmAsAdmin: () => void;
  confirmAsDriver: () => void;
  confirmAsServiceTechnican: () => void;
}

export const generateItems = (quantity: IQuantity, actions: IActions, t: any) => {
  switch (quantity) {
    case Quantity.ONE:
      return [
        {
          key: "confirm",
          text: t('notConfirmedUsers.commands.confirm'),
          iconProps: { iconName: "WaitlistConfirm" },
          name: "edit",
          onClick: actions.openPanelToConfirm,
          subMenuProps: {
            items: [{
              key: "confirmAsAdmin",
              text: t('notConfirmedUsers.commands.confirmAsAdmin'),
              iconProps: { iconName: "Admin" },
              name: "edit",
              onClick: actions.confirmAsAdmin,
            },
            {
              key: "confirmAsDriver",
              text: t('notConfirmedUsers.commands.confirmAsDriver'),
              iconProps: { iconName: "Car" },
              name: "edit",
              onClick: actions.confirmAsDriver,
            },
            {
              key: "confirmAsServiceTechnican",
              text: t('notConfirmedUsers.commands.confirmAsServiceTechnician'),
              iconProps: { iconName: "CRMServices" },
              name: "edit",
              onClick: actions.confirmAsServiceTechnican,
            }
            ],
          }
        }
      ];
    default:
      return [];
  }
};